/**
 * @fileoverview Which regime a declarant reports under.
 *
 * One reading, shared. The route guards already answer this question
 * (`_routes.jsx`), and the Upload Hub's dropzone now has to answer it too —
 * two independent readings of the same nullable field is how a gate and the
 * thing it gates come to disagree, and a dropzone that accepted a file the
 * router would then refuse to route is exactly that bug.
 *
 * Every declarant carries `regulation` (`'EU' | 'UK'`, backend default
 * `'EU'`). Absent — a declarant not loaded yet, or a non-declarant org —
 * still resolves to `'EU'`, so nothing UK-gated opens on a missing answer.
 */

/**
 * @param {Object} [declarant] `useFetchDeclarant`'s answer.
 * @returns {boolean}
 */
export const isUkRegulation = (declarant) => (declarant?.regulation ?? 'EU') === 'UK';

/**
 * Countries a UK CBAM installation cannot be in: UK-origin goods are outside
 * UK CBAM, and the server refuses them (`UK_ORIGIN_EXCLUDED`). For the
 * `excludeIso2` prop of the country selects — one module-level array, so it
 * is referentially stable in their hook dependencies.
 */
export const UK_INSTALLATION_EXCLUDED_ISO2 = Object.freeze(['GB']);

export default isUkRegulation;
